export enum AppModes {
    KINSHIP = "Kinship",
    CARRIERSCREENING = "Carrier Screening",
    COMPREHENSIVEWELLNESS = "Comprehensive Health",
    LUMIWELLNESS = "Lumi Wellness"
}